export const INVITATION_BEGIN_WRITE_DATA = 'INVITATION/BEGIN_WRITE_DATA';
export const INVITATION_COMPLETE_WRITE_DATA = 'INVITATION/COMPLETE_WRITE_DATA';
export const INVITATION_REQUEST_DATA = 'INVITATION/REQUEST_DATA';
export const FETCH_INVITATIONS = 'INVITATION/FETCH_INVITATIONS';
export const RECEIVE_INVITATIONS = 'INVITATION/RECEIVE_INVITATIONS';
